import { render } from "./Auteur.vue?vue&type=template&id=c3b1a780&scoped=true"
import script from "./Auteur.vue?vue&type=script&lang=js"
export * from "./Auteur.vue?vue&type=script&lang=js"

import "./Auteur.vue?vue&type=style&index=0&id=c3b1a780&scoped=true&lang=css"

import exportComponent from "C:\\Users\\gaglo\\OneDrive\\Bureau\\top_chronique\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3b1a780"]])

export default __exports__